<mf-page title="Nueva orden de pago">
  @if (paymentOrderDto) {
  <mf-payment-order
    [paymentOrderDto]="paymentOrderDto"
    (close)="close()"
    (save)="save($event)" />
  }
</mf-page>
